import { useEffect } from 'react';

import { useRouter } from 'next/router';

import I18n from '~/src/common/services/I18n';
import Toaster from '~/src/common/services/Toaster';
import { ToasterMessage } from '~/src/screens/Home/layout';

const useHomeNotifications = (openCartModal: () => Promise<void>) => {
  const { query } = useRouter<{
    ordercancelled?: string;
    iscartopen?: string;
  }>();

  useEffect(() => {
    if (query?.ordercancelled) {
      Toaster.notify({
        icon: 'info',
        message: (
          <ToasterMessage>
            <p>{I18n.t('home.update-order.toaster.title')}</p>
            <p>{I18n.t('home.update-order.toaster.content')}</p>
          </ToasterMessage>
        ),
      });
    }

    if (query?.iscartopen || query?.ordercancelled) {
      void openCartModal();
    }
  }, [query?.ordercancelled, query?.iscartopen, openCartModal]);
};

export default useHomeNotifications;
